export interface ArticleItem {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  thumbnail: string;
  date: string;
  author: string;
  tags: string[];
  views: string;
}

export const articles: ArticleItem[] = [
  {
    id: 'a1',
    title: '《流浪地球3》票房突破50亿，国产科幻再创辉煌',
    summary: '《流浪地球3》上映以来口碑票房双丰收，以震撼的视觉效果和深刻的人文关怀征服了全球观众，成为国产科幻电影的里程碑之作。',
    content: `<p>《流浪地球3》自上映以来，凭借震撼的视觉效果和深刻的人文主题，迅速在全球范围内掀起观影热潮。截至本周，影片全球票房已突破50亿人民币，成为2026年最卖座的华语电影。</p>
    <p>导演郭帆在接受采访时表示，第三部在技术层面实现了全面升级，团队自主研发的多项特效技术达到了国际一流水准。影片中的太空场景和灾难场面全部由国产特效团队完成，展现了中国电影工业的巨大进步。</p>
    <p>影片延续了前两部的"带着地球去流浪"这一独特设定，讲述了人类在漫长的星际旅程中面临的新的生存挑战。吴京、刘德华等主演的精彩表演也为影片增色不少。</p>
    <p>业内人士分析，《流浪地球3》的成功不仅仅是票房数字的突破，更标志着中国科幻电影已经形成了自己的美学风格和叙事体系，正在成为全球科幻电影的重要力量。</p>
    <p>观众纷纷表示："每一帧都可以当壁纸"、"看完热血沸腾"、"这才是中国科幻该有的样子"。影片目前仍在热映中，预计最终票房有望冲击60亿。</p>`,
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20futuristic%20spaceship%20near%20Earth%2C%20dramatic%20orange%20and%20teal%20grading%2C%20epic%20scale%2C%20high%20production%20value%20film%20still&width=800&height=450&seq=boluo-article-a1&orientation=landscape',
    date: '2026-08-05',
    author: '影视编辑',
    tags: ['电影', '科幻', '票房', '流浪地球'],
    views: '28.5万',
  },
  {
    id: 'a2',
    title: '《狂飙》凭什么成为年度现象级剧王？深度解析',
    summary: '从剧情设定到人物塑造，从社会意义到表演艺术，深度解读《狂飙》为何能够成为中国电视剧史上的一座丰碑。',
    content: `<p>《狂飙》自播出以来，不仅收视率屡创新高，更在社交媒体上引发了持续不断的讨论热潮。作为一部扫黑除恶题材的电视剧，它为何能突破类型限制，成为全民关注的文化现象？</p>
    <p><strong>一、真实有力的人物塑造</strong></p>
    <p>剧中高启强从一个普通鱼贩到黑恶势力头目的转变，展现了人性在特定社会环境下的复杂变化。张颂文老师的表演入木三分，让观众既痛恨其恶行，又能理解其悲剧命运。</p>
    <p><strong>二、跨越二十年的时代画卷</strong></p>
    <p>从2000年到2021年，剧集通过三个时间节点，全景式展现了中国社会二十年的巨大变迁。城市面貌、人物着装、生活习惯等细节都经过精心考据。</p>
    <p><strong>三、深刻的现实主义底色</strong></p>
    <p>《狂飙》不回避社会矛盾，以纪实手法呈现了基层治理的复杂性和扫黑除恶的艰巨性，引发了观众对社会正义的深层思考。</p>
    <p>这部剧的成功，标志着国产剧集已经进入了一个更加成熟、更有深度的创作阶段。</p>`,
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20show%20scene%20with%20intense%20confrontation%20between%20two%20actors%2C%20dark%20moody%20lighting%2C%20film%20noir%20cinematography%2C%20dramatic%20atmosphere&width=800&height=450&seq=boluo-article-a2&orientation=landscape',
    date: '2026-07-28',
    author: '剧评人',
    tags: ['电视剧', '国产剧', '狂飙', '剧评'],
    views: '45.2万',
  },
  {
    id: 'a3',
    title: '2026暑期档：五部不可错过的国产动画电影',
    summary: '暑期档历来是动画电影的必争之地，今年更是有多部制作精良的国产动画值得期待。',
    content: `<p>随着国产动画工业体系的日趋成熟，每年暑期档都有令人惊喜的动画电影上映。2026年同样不例外，我们为大家精选了五部最值得期待的国产动画电影。</p>
    <p><strong>1.《哪吒之魔童闹海》续作</strong></p>
    <p>继前作创下票房奇迹后，这部续作在视觉效果和故事深度上都有了质的飞跃。</p>
    <p><strong>2.《深海》导演新作《星海》</strong></p>
    <p>延续了前作令人惊艳的美术风格，讲述了一段关于勇气与友谊的星际冒险故事。</p>
    <p><strong>3.《西游记之大圣归来2》</strong></p>
    <p>时隔多年，大圣终于归来。制作团队表示，这次将呈现更加宏大的神话世界。</p>
    <p><strong>4.《白蛇：浮生》</strong></p>
    <p>追光动画最新力作，将传统民间故事与现代审美完美结合。</p>
    <p><strong>5.《山海经之再见怪兽》</strong></p>
    <p>以《山海经》为蓝本，用现代视角重新诠释中国上古神话。</p>
    <p>这个暑期档，国产动画诚意满满，总有一部适合你！</p>`,
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20collage%20with%20various%20animation%20styles%2C%20colorful%20and%20magical%20atmosphere%2C%20fantasy%20elements%2C%20movie%20poster%20collection&width=800&height=450&seq=boluo-article-a3&orientation=landscape',
    date: '2026-08-01',
    author: '动画专栏',
    tags: ['动画', '暑期档', '国产动画', '电影推荐'],
    views: '18.7万',
  },
  {
    id: 'a4',
    title: '《乘风破浪的姐姐》第五季：姐姐们的舞台魅力全解析',
    summary: '新一季的姐姐们带来了更多惊喜和感动，从初舞台到成团夜，每一个瞬间都值得回味。',
    content: `<p>《乘风破浪的姐姐》第五季再次证明了"姐姐"IP的强大生命力。本季节目在赛制、舞台设计和选手配置上都有了新的突破。</p>
    <p><strong>赛制升级：更公平的竞争机制</strong></p>
    <p>本季引入了"队长轮值制"和"踢馆赛制"，让比赛更加扣人心弦。姐姐们不仅要展现个人实力，还要带领团队取得胜利。</p>
    <p><strong>舞台设计：视听盛宴</strong></p>
    <p>每一个公演舞台都堪称MV级别的制作。从国风到现代，从柔情到炸裂，多元化的舞台呈现让观众大饱眼福。</p>
    <p><strong>选手阵容：跨领域姐姐齐聚</strong></p>
    <p>本季选手涵盖了演员、歌手、主持人、运动员等多个领域，每一位姐姐都带来了独特的魅力。</p>
    <p>节目播出至今，相关话题累计阅读量超过50亿，再次证明了"姐姐"这个IP的持久魅力。</p>`,
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20with%20female%20performers%20dancing%2C%20colorful%20stage%20lights%2C%20glamorous%20entertainment%20show%20design%2C%20energetic%20performance&width=800&height=450&seq=boluo-article-a4&orientation=landscape',
    date: '2026-07-20',
    author: '综艺观察',
    tags: ['综艺', '乘风破浪', '舞台', '女团'],
    views: '32.6万',
  },
  {
    id: 'a5',
    title: '纪录片推荐：五部让你重新认识世界的自然纪录片',
    summary: '从深海到极地，从丛林到沙漠，这五部自然纪录片将带你领略地球上最震撼的自然奇观。',
    content: `<p>自然纪录片有一种独特的魔力——它让我们在客厅的沙发上就能领略地球上最壮美的风景和最神奇的生物。以下是五部值得反复观看的自然纪录片。</p>
    <p><strong>1.《地球脉动》系列</strong></p>
    <p>BBC的经典之作，每一帧都可以当壁纸。从企鹅到雪豹，从深海到高山，展现了地球生命的多样性。</p>
    <p><strong>2.《蓝色星球》系列</strong></p>
    <p>深入海洋世界，揭示了超过200种此前从未被拍摄到的海洋生物。</p>
    <p><strong>3.《我们的星球》</strong></p>
    <p>Netflix出品，4K超高清画质，记录了全球50个国家的自然奇观和野生动物的生存状态。</p>
    <p><strong>4.《王朝》</strong></p>
    <p>以故事化的手法讲述五个动物家族的生存、繁衍和权力斗争，如同动物版的《权力的游戏》。</p>
    <p><strong>5.《七个世界，一个星球》</strong></p>
    <p>以七大洲为线索，展现每个大陆上独特的野生动物和自然奇观。</p>
    <p>这些纪录片不仅画面震撼，更能引发我们对自然保护的思考。</p>`,
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20stunning%20scene%20with%20polar%20bears%20on%20ice%2C%20dramatic%20arctic%20landscape%2C%20BBC%20style%20cinematography%2C%20epic%20scale%20wildlife%20photography&width=800&height=450&seq=boluo-article-a5&orientation=landscape',
    date: '2026-07-15',
    author: '纪录片频道',
    tags: ['纪录片', '自然', '推荐', 'BBC'],
    views: '15.3万',
  },
  {
    id: 'a6',
    title: '从《三体》到《流浪地球》：中国科幻影视的黄金时代来了',
    summary: '从小说到银幕，中国科幻正在经历一场前所未有的爆发。是什么催生了这股科幻热潮？',
    content: `<p>2023年被称为"中国科幻元年"——这一年，《三体》电视剧和《流浪地球2》相继与观众见面，都取得了令人瞩目的成绩。三年过去，中国科幻影视不仅没有降温，反而进入了更加蓬勃的发展阶段。</p>
    <p><strong>技术突破是基石</strong></p>
    <p>从《流浪地球》系列开始，国产特效技术实现了质的飞跃。如今的中国特效团队已经能够独立完成好莱坞级别的视效制作。</p>
    <p><strong>文学底蕴是灵魂</strong></p>
    <p>刘慈欣、王晋康、何夕等科幻作家的作品为影视改编提供了丰富的素材库。《三体》获得雨果奖更是让中国科幻受到全球瞩目。</p>
    <p><strong>观众成熟是关键</strong></p>
    <p>新一代观众对科幻题材的接受度和鉴赏力显著提高，愿意为高质量的国产科幻作品买单。</p>
    <p>中国科幻影视的黄金时代，刚刚开始。</p>`,
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20scene%20with%20futuristic%20city%20and%20spaceship%2C%20cyberpunk%20aesthetic%20mixed%20with%20Chinese%20elements%2C%20dramatic%20cinematography%2C%20epic%20atmosphere&width=800&height=450&seq=boluo-article-a6&orientation=landscape',
    date: '2026-07-10',
    author: '影视编辑',
    tags: ['科幻', '三体', '流浪地球', '国产影视'],
    views: '22.1万',
  },
];